import { useQuery } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useGetBanners = () => {
  const { token } = useContext(AuthContext);

  return useQuery(
    "banners",
    async () => {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/banners/all`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    },
    { enabled: !!token }
  );
};

export default useGetBanners;
